import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Table, FormGroup, FormControl, InputGroup, Panel, ControlLabel, Glyphicon, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import { FahrzeugTyp, SES_TYP } from '../../../models/ApiTypes';
import { SesAufstellflaechenTyp } from '../../../models/ApiTypesSes';
import Callout from '../../site/Callout';
import { bind, inject } from '../../../utils/decorators';
import { ApiStore } from '../../../stores/ApiStore';
import { VorgangStore } from '../../../stores/VorgangStore';
import { UiStore } from '../../../stores/UiStore';
import SesAuswertungSystemneigung from './SesAuswertungSystemneigung';
import { SesAuswertungFlaechenRili2018Store } from '../../../stores/SesAuswertungFlaechenRili2018Store';
import SesAuswertungFlaechenMesswertValidierung from './SesAuswertungFlaechenMesswertValidierung';
import { ISesAuswertungFlaechenProps, ISesBeurteilungsErgebnis, ISesFlaeche, ISesFahrspur, ISesMesspunktErgebnis, ISesMesswerte, ISesMesspunkte, ISesMessung } from '../../../models/ApiTypesSes';

/** Messwerteingabe und -auswertung für Scheinwerfer-Einstellprüfsysteme nach Richtlinie 2018 */
@observer
export default class SesAuswertungFlaechenRili2018 extends React.Component<ISesAuswertungFlaechenProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  @inject(VorgangStore) vorgangStore: VorgangStore;
  @observable auswertungDownloadLink: string;
  @observable maximaleSpurAnzahl: number = 0;
  @observable fahrzeugAusgefuellt: boolean = false;
  @observable sepAusgefuellt: boolean = false;
  @observable abfrageStatus: undefined | 'angefordert' | 'abgeschlossen';

  componentWillMount() {
    this.store.eingabenLaden(this.props.vorgangId);
    this.store.setEditable(this.props.editable);
  }

  async componentDidMount() {
    this.store.clear();
    this.setAbfrageStatus('angefordert');
    const { auftragId } = this.props;
    let auftrag = await this.apiStore.auftragDetails(auftragId);
    if (auftrag.ok) {
      const fahrzeugTypMeta = auftrag.json.meta.find(meta => meta.bezeichnung === SES_TYP);
      if (fahrzeugTypMeta) {
        this.handleSetFahrzeugTyp(fahrzeugTypMeta.inhalt as FahrzeugTyp);
      }
    }
    this.setAbfrageStatus('abgeschlossen');
  }

  @bind @action setAbfrageStatus(status: undefined | 'angefordert' | 'abgeschlossen') {
    this.abfrageStatus = status;
  }

  @bind @action handleSetFahrzeugTyp(fahrzeugTyp: FahrzeugTyp) {
    this.store.messwerteFahrzeug.typ = fahrzeugTyp;
    this.setzeSpurAnzahl(fahrzeugTyp);
  }

  @bind async handleAuswertungErzeugen() {
    const { vorgangId } = this.props;
    const messwerteFahrzeug = this.store.messwerteFahrzeug;
    if (vorgangId) {
      let messung: ISesMessung = {
        messpunkte: messwerteFahrzeug.messpunkte,
        messwerte: {
          links: messwerteFahrzeug.messwerte.links,
          rechts: messwerteFahrzeug.messwerte.rechts
        },
        fahrspur: messwerteFahrzeug.fahrspur,
        flaeche: messwerteFahrzeug.flaeche,
        typ: messwerteFahrzeug.typ,
        sperrpunkte: messwerteFahrzeug.sperrpunkte,
        sperrflaechen: []
      };
      messung.messpunkte = messung.messpunkte.slice(0, this.maximaleSpurAnzahl);
      messung.messwerte.links = messung.messwerte.links.slice(0, this.maximaleSpurAnzahl);
      messung.messwerte.rechts = messung.messwerte.rechts.slice(0, this.maximaleSpurAnzahl);

      // Eingaben zwischenspeichern (für evtl. spätere Weiterbearbeitung)
      try {
        await this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, messung, this.store.messwerteSep);
        console.log('Eingaben gespeichert');
      } catch (error) {
        console.log('Eingaben konnten nicht zwischengespeichert werden');
      }

      // Auswertung erzeugen und Dokument zum Download anbieten
      const response = await this.apiStore.erzeugeDokumentAuswertungRili2018(
        vorgangId,
        messung,
        this.store.messwerteSep
      );
      if (response.ok) {
        const downloadLink = await this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid as string);
        window.open(downloadLink);

        this.vorgangStore.loadVorgang(vorgangId);
        if (this.props.onTriggerDocumentRefresh) {
          this.props.onTriggerDocumentRefresh();
        }
      }
    }
  }

  @bind @action setzeSpurAnzahl(messTyp: FahrzeugTyp) {
    // @todo: rework
    let laenge = 0;
    switch (messTyp) {
      case 'KRAD':
        laenge = 2500;
        this.maximaleSpurAnzahl = (2500 / this.store.messRaster) + 1;
        break;
      case 'PKW':
        laenge = 4000;
        this.maximaleSpurAnzahl = (4000 / this.store.messRaster) + 1;
        break;
      case 'LKW':
        laenge = 8000;
        break;
      default:
        laenge = 0;
        this.maximaleSpurAnzahl = 0;
    }
    if (laenge > 0) {
      this.maximaleSpurAnzahl = (laenge / this.store.messRaster) + 1;
      this.store.messwerteFahrzeug.fahrspur.laenge = laenge.toString();
    }
  }

  @bind @action fahrzeugAusgefuelltHandler(wert: boolean) {
    this.fahrzeugAusgefuellt = wert;
    if (wert) {
      this.store.validateMesswerteDelayed('fahrzeug', this.maximaleSpurAnzahl);
    }
  }

  @bind @action sepAusgefuelltHandler(wert: boolean) {
    this.sepAusgefuellt = wert;
    if (wert) {
      this.store.validateMesswerteDelayed('sep', this.maximaleSpurAnzahl);
    }
  }

  render() {
    const { store } = this;

    // Wenn die Auswertung read-only in einem abgeschlossenen Vorgang angezeigt werden soll, es aber keine gespeicherten Werte gibt (vor Einführung der Funktion) soll nichts angezeigt werden
    if (!this.store.editable && !this.store.gespeicherteEingabenVorhanden) {
      return <div/>;
    }

    if (this.abfrageStatus !== 'abgeschlossen') {
      return <div className="maxwidth">lade Messwerteingabe...</div>;
    }

    if (this.maximaleSpurAnzahl === 0) {
      return (
        <Callout bsStyle="info">
          <h4>Auswahl erforderlich!</h4>
          <p>Bevor Sie fortfahren können, muss die <b>Fahrzeugkategorie</b> angegeben werden.</p>
          <div className="text-right">
            <Button bsStyle="info" type="submit" onClick={() => this.uiStore.navigateTo(`/auftrag/${this.props.auftragId}/auftraggeber`)}>Fahrzeugkategorie ändern</Button>
          </div>
        </Callout>
      );
    }

    return (
      <div className="auswertung-messwerte">
        <Aufstellflaeche
          aufstellflaechenTyp="fahrzeug"
          messung={store.messwerteFahrzeug}
          beurteilungsErgebnis={store.beurteilungFahrzeug}
          maximaleSpurAnzahl={this.maximaleSpurAnzahl}
          vollstaendigAusgefuelltHandler={this.fahrzeugAusgefuelltHandler}
        />
        <Aufstellflaeche
          aufstellflaechenTyp="sep"
          beurteilungsErgebnis={store.beurteilungSep}
          messung={store.messwerteSep}
          maximaleSpurAnzahl={11}
          vollstaendigAusgefuelltHandler={this.sepAusgefuelltHandler}
        />

        {this.store.editable &&
          <Callout bsStyle="success">
            <p>Speichert die aktuell eingegebenen Daten. Bereits gespeicherte Daten können jederzeit, bis zum Erstellen der Auswertung, ergänzt und korrigiert werden.</p>
            <div className="text-right">
              {this.store.zeitpunktGespeichert && <span className="text-hint-light">Gespeichert am {this.store.zeitpunktGespeichert}</span>}<Button bsStyle="success" onClick={() => this.store.eingabenSpeichern(this.props.vorgangId)} /*disabled={this.requestInProgress}*/>Speichern</Button>
            </div>
          </Callout>}

        {this.props.vorgangId && this.store.editable && (
          (this.fahrzeugAusgefuellt && this.sepAusgefuellt)
            ?
            <div>
              <SesAuswertungSystemneigung
                richtlinie={'2018'}
                neigungenFZ={store.beurteilungFahrzeug.neigungen}
                neigungenSEP={store.beurteilungSep.neigungen}
                beurteilungFZ={store.beurteilungFahrzeug}
                beurteilungSEP={store.beurteilungSep}
              />
              <Callout bsStyle="warning">
                <h4><Glyphicon glyph="warning-sign" /> Auswertung</h4>
                <p>
                  Erzeugt auf Basis der Eingabedaten und errechneten Werte eine Auswertung der Flächen als PDF Dokument das im Vorgang hinterlegt wird.<br/><br/>
                  Der Vorgang wird dadurch abgeschlossen, ein Ändern der Werte ist nachträglich nur über einen Korrekturvorgang möglich. Der Zugriff auf die erzeugte Auswertung als PDF ist weiterhin jederzeit möglich.
                </p>
                <div className="text-right">
                  <Button bsStyle="warning" type="submit" onClick={this.handleAuswertungErzeugen}>Auswertung erzeugen</Button>
                </div>
              </Callout>
            </div>
            :
            <Callout bsStyle="danger">
              Das Erzeugen der Auswertung ist erst möglich wenn für beide Aufstellflächen alle benötigten Messwerte eingegeben wurden.
            </Callout>
        )}

      </div>
    );
  }
}

interface IAufstellflaechenProps {
  messung: ISesMessung;
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  beurteilungsErgebnis: ISesBeurteilungsErgebnis;
  maximaleSpurAnzahl: number;
  vollstaendigAusgefuelltHandler: (wert: boolean) => void;
}

@observer
class Aufstellflaeche extends React.Component<IAufstellflaechenProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;

  @observable messwerteAusgefuellt: boolean = false;
  @observable gesamtAusgefuellt: boolean = false;

  @bind @action setzeMesswerteAusgefuellt(wert: boolean) {
    this.messwerteAusgefuellt = wert;
    this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
  }

  @bind @action setzeGesamtAusgefuellt(wert: boolean) {
    this.gesamtAusgefuellt = wert;
    this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
  }

  render() {
    const { aufstellflaechenTyp, messung, beurteilungsErgebnis } = this.props;

    let label = '';
    let messunsicherheit;
    if (aufstellflaechenTyp === 'fahrzeug') {
      label = 'Messwerte: Fahrzeug-Aufstellfläche';
      if (messung.typ) {
        label += ` ${messung.typ}`;
      }
      messunsicherheit = <div>Messunsicherheit U(k=2) = 0,3mm + 1 * 10<sup>-4</sup> * l</div>;
    } else {
      label = 'Messwerte: SEP-Aufstellfläche';
      messunsicherheit = <div>Messunsicherheit U(k=2) = 0,15mm/m</div>;
    }

    return (
      <Panel header={label} className="messwerte-sep" collapsible={true} defaultExpanded={true} footer={(<small>{messunsicherheit}</small>)}>
        <AufstellflaecheMesswerte
          messung={messung}
          aufstellflaechenTyp={aufstellflaechenTyp}
          beurteilungsErgebnis={beurteilungsErgebnis}
          maximaleSpurAnzahl={this.props.maximaleSpurAnzahl}
          vollstaendigAusgefuelltHandler={this.setzeMesswerteAusgefuellt}
        />

        <AufstellflaecheGesamt
          fahrspur={messung.fahrspur}
          flaeche={messung.flaeche}
          aufstellflaechenTyp={aufstellflaechenTyp}
          beurteilungsErgebnis={beurteilungsErgebnis}
          vollstaendigAusgefuelltHandler={this.setzeGesamtAusgefuellt}
        />

        {this.store.editable &&
          <SesAuswertungFlaechenMesswertValidierung
            beurteilungsErgebnis={beurteilungsErgebnis}
            aufstellflaechenTyp={aufstellflaechenTyp}
            vollstaendigAusgefuellt={this.messwerteAusgefuellt && this.gesamtAusgefuellt}
          />}

      </Panel>
    );
  }
}

interface IAufstellflaecheMesswerteProps {
  messung: ISesMessung;
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  beurteilungsErgebnis: ISesBeurteilungsErgebnis;
  maximaleSpurAnzahl: number;
  vollstaendigAusgefuelltHandler: (wert: boolean) => void;
}

@observer
class AufstellflaecheMesswerte extends React.Component<IAufstellflaecheMesswerteProps, {}> {

  vollstaendigAusgefuellt() {
    const messung = this.props.messung;
    let ergebnis =
      (messung.messpunkte.length > 0) &&
      (messung.messpunkte.every((wert, index) => (index >= this.props.maximaleSpurAnzahl) || (wert !== ''))) &&
      (messung.messpunkte.every((wert, index, werte) => (index === 0) || (index >= this.props.maximaleSpurAnzahl) || (parseFloat(wert) > parseFloat(werte[index - 1]))))  &&
      (messung.messwerte.links.every((wert, index) => (index >= this.props.maximaleSpurAnzahl) || (wert !== '') || (messung.sperrpunkte[index] === true))) &&
      (messung.messwerte.rechts.every((wert, index) => (index >= this.props.maximaleSpurAnzahl) || (wert !== '') || (messung.sperrpunkte[index] === true)));
    return ergebnis;
  }

  @bind ausgefuelltHandler() {
    this.clearBeurteilung();
    let ergebnis = this.vollstaendigAusgefuellt();
    this.props.vollstaendigAusgefuelltHandler(ergebnis);
  }

  componentDidMount() {
    let ergebnis = this.vollstaendigAusgefuellt();
    if (ergebnis) {
      this.props.vollstaendigAusgefuelltHandler(ergebnis);
    }
  }

  @bind @action clearBeurteilung() {
    this.props.beurteilungsErgebnis.beurteilung = [];
  }

  render() {
    const {aufstellflaechenTyp, beurteilungsErgebnis, messung} = this.props;

    const spurMesspunkte = [];
    for (let i = 0; i < this.props.maximaleSpurAnzahl; i++) {
      spurMesspunkte.push(
        <SpurMesspunkt
          key={i}
          index={i}
          labelLinks={`P${i}`}
          labelRechts={`P${this.props.maximaleSpurAnzahl + i}`}
          messpunkte={messung.messpunkte}
          messwerte={messung.messwerte}
          aufstellflaechenTyp={aufstellflaechenTyp}
          beurteilungsErgebnis={beurteilungsErgebnis}
          onChange={this.ausgefuelltHandler}
          sperrpunkte={messung.sperrpunkte}
        />
      );
    }

    return (
      <Table striped={false} bordered={true} condensed={true} hover={false} className="aufstellflaeche-punkte">
        <thead>
          <tr>
            <th style={{textAlign: 'center'}}>Abstand <small>[mm]</small></th>
            <th style={{textAlign: 'center'}}>Höhendifferenz<br/>{aufstellflaechenTyp === 'sep' ? 'Vordere' : 'Linke'} Fahrspur <small>[mm]</small></th>
            <th style={{textAlign: 'center'}}>Höhendifferenz<br/>{aufstellflaechenTyp === 'sep' ? 'Hintere' : 'Rechte'} Fahrspur <small>[mm]</small></th>
            {aufstellflaechenTyp === 'fahrzeug' && <th>Sperrfläche<br/>vorhanden</th>}
          </tr>
        </thead>
        <tbody>
          {spurMesspunkte.map((punkt) => punkt)}
        </tbody>
      </Table>
    );
  }
}

interface IAufstellflaecheGesamtProps {
  fahrspur: ISesFahrspur;
  flaeche: ISesFlaeche;
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  beurteilungsErgebnis: ISesBeurteilungsErgebnis;
  vollstaendigAusgefuelltHandler: (wert: boolean) => void;
}

@observer
class AufstellflaecheGesamt extends React.Component<IAufstellflaecheGesamtProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;

  popoverErmittelteSteigung = (
    <Popover id="popover-trigger-hover-focus">
      Übernimmt die automatisch anhand der Eingabewerte ermittelte mittlere {this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Längsneigung' : 'Querneigung'} als Steigung der Fläche.<br/><br/>
      Die automatische Ermittlung versucht eine Steigung zu errechnen bei der alle Werte
      innerhalb des Toleranzbereiches liegen.
    </Popover>
  );

  popoverSpurweite = (
    <Popover id="popover-trigger-hover-focus">
      Tragen Sie hier die <b>gemessene Spurweite</b> der {this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Fahrzeug-Aufstellfläche' : 'SEP-Aufstellfläche'} ein.
      {this.props.aufstellflaechenTyp === 'sep' ? <span><br/><br/>Die Spurweite der Aufstellfläche muss <b>zwischen 400 und 1000 mm</b> liegen.</span> : ''}
    </Popover>
  );

  vollstandigAusgefuellt() {
    let result = false;
    result = (this.props.fahrspur.breite !== '') && (parseInt(this.props.fahrspur.breite, 10) > 0) && (this.props.fahrspur.laenge !== '') && (parseInt(this.props.fahrspur.laenge, 10) > 0);
    if (this.props.aufstellflaechenTyp === 'sep') {
      result = result && (this.props.flaeche.steigung !== '');
    }
    return result;
  }

  @bind @action ubernehmeErmittelteSteigung() {
    if (this.props.beurteilungsErgebnis !== null) {
      this.props.flaeche.steigung = this.props.beurteilungsErgebnis.neigungen.ermittelt.toString();
      this.ausgefuelltHandler();
    }
  }

  @bind @action ausgefuelltHandler() {
    this.props.beurteilungsErgebnis.beurteilung = [];
    this.props.vollstaendigAusgefuelltHandler(this.vollstandigAusgefuellt());
  }

  @bind @action handleBreiteChanged(event: React.FormEvent<FormControl>) {
    let value = (event.target as HTMLInputElement).value;
    this.props.fahrspur.breite = value;
    this.ausgefuelltHandler();
  }

  @bind @action handleLaengeChanged(event: React.FormEvent<FormControl>) {
    let value = (event.target as HTMLInputElement).value;
    this.props.fahrspur.laenge = value;
    this.ausgefuelltHandler();
  }

  @bind @action handleSteigungChanged(event: React.FormEvent<FormControl>) {
    let value = (event.target as HTMLInputElement).value;
    this.props.flaeche.steigung = value;
    this.ausgefuelltHandler();
  }

  componentDidMount() {
    this.ausgefuelltHandler();
  }

  render() {
    const laenge = this.props.fahrspur.laenge;
    const breite = this.props.fahrspur.breite;
    const steigung = this.props.flaeche.steigung;

    let optimaleNeigung = undefined;
    if (this.props.beurteilungsErgebnis) {
      optimaleNeigung = this.props.beurteilungsErgebnis.neigungen.ermittelt && this.props.beurteilungsErgebnis.neigungen.ermittelt;
    }

    let validationStateSpurweite: 'warning' | undefined = undefined;
    if (((breite === '') || (parseInt(breite, 10) <= 0))) {
      validationStateSpurweite = 'warning';
    }
    // Wertebereich SEP-Aufstellfläche einschränken
    if (this.props.aufstellflaechenTyp === 'sep') {
      if ((parseInt(breite, 10) < 400) || (parseInt(breite, 10) > 1000)) {
        validationStateSpurweite = 'warning';
      }
    }

    return (
      <Table striped={true} bordered={true} condensed={true} hover={true} className="aufstellflaeche-global">
        <tbody>
          <tr>
            <th>Fahrspur</th>
            <td>
              <FormGroup
                validationState={validationStateSpurweite}
                controlId={'breite'}
              >
                <InputGroup>
                  <InputGroup.Addon>
                    <ControlLabel>Spurweite</ControlLabel>
                  </InputGroup.Addon>
                  <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={this.popoverSpurweite}>
                    <FormControl
                      type="number"
                      step="any"
                      className="input-fahrspurbreite"
                      value={breite}
                      onChange={this.handleBreiteChanged}
                      readOnly={!this.store.editable}
                    />
                  </OverlayTrigger>
                  <InputGroup.Addon style={{ width: '62px'}}><small>mm</small></InputGroup.Addon>
                </InputGroup>
              </FormGroup>
            </td>

            <td>
              <FormGroup validationState={((laenge === '') || (parseInt(laenge, 10) <= 0)) ? 'warning' : undefined} controlId={'laenge'}>
                <InputGroup>
                  <InputGroup.Addon>
                    <ControlLabel>Länge</ControlLabel>
                  </InputGroup.Addon>
                  <FormControl
                    type="number"
                    readOnly={true}
                    step="any"
                    className="input-fahrspurlaenge"
                    value={laenge}
                    onChange={this.handleLaengeChanged}
                  />
                  <InputGroup.Addon style={{ width: '62px'}}><small>mm</small></InputGroup.Addon>
                </InputGroup>
              </FormGroup>
            </td>
          </tr>
          {this.props.aufstellflaechenTyp === 'sep' &&
            <tr>
              <th>Steigung</th>
              <td>
                <FormGroup validationState={(steigung === '') ? 'warning' : undefined} controlId={'steigung'}>
                  <InputGroup>
                    <InputGroup.Addon>
                      <ControlLabel>Gemessen</ControlLabel>
                    </InputGroup.Addon>
                    <FormControl
                      type="number"
                      step="any"
                      className="input-flaechensteigung"
                      value={steigung}
                      onChange={this.handleSteigungChanged}
                      readOnly={!this.store.editable}
                    />
                    <InputGroup.Addon style={{ width: '62px'}}><small>mm/m</small></InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </td>
              <td>
                {this.store.editable &&
                  <FormGroup controlId={'steigung-optimal'}>
                    <InputGroup>
                      <InputGroup.Addon>
                        <ControlLabel>Vorschlag</ControlLabel>
                      </InputGroup.Addon>
                      <FormControl
                        type="number"
                        step="any"
                        className="input-flaechensteigung"
                        value={this.vollstandigAusgefuellt() ? optimaleNeigung : ''}
                        readOnly={true}
                      />
                      <InputGroup.Button>
                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={this.popoverErmittelteSteigung}>
                        <Button
                          bsStyle={this.vollstandigAusgefuellt() ? 'success' : 'default'}
                          className="btn-group"
                          disabled={!this.vollstandigAusgefuellt()}
                          onClick={this.ubernehmeErmittelteSteigung}>
                          Übernehmen
                        </Button>
                        </OverlayTrigger>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                }
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

interface ISpurMesspunktProps {
  index: number;
  messwerte: ISesMesswerte;
  messpunkte: ISesMesspunkte;
  labelLinks: string;
  labelRechts: string;
  beurteilungsErgebnis: ISesBeurteilungsErgebnis;
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  sperrpunkte: boolean[];
  onChange: () => void;
}

@observer
class SpurMesspunkt extends React.Component<ISpurMesspunktProps, {}> {

  render() {
    const { index, messpunkte, messwerte, aufstellflaechenTyp, beurteilungsErgebnis, labelLinks, labelRechts, sperrpunkte } = this.props;

    let beurteilungLinks;
    let beurteilungRechts;

    if (index < beurteilungsErgebnis.beurteilung.length && beurteilungsErgebnis.beurteilung[index]) {
      beurteilungLinks = beurteilungsErgebnis.beurteilung[index].links;
      beurteilungRechts = beurteilungsErgebnis.beurteilung[index].rechts;
    }

    return (
      <tr>
        <td>
          <AbstandFeld
            values={messpunkte}
            index={index}
            aufstellflaechenTyp={aufstellflaechenTyp}
            onChange={this.props.onChange}
          />
        </td>
        <td>
          <HoehendifferenzFeld
            label={labelLinks}
            values={messwerte.links}
            sperrpunkte={sperrpunkte}
            beurteilung={beurteilungLinks}
            index={index}
            aufstellflaechenTyp={aufstellflaechenTyp}
            onChange={this.props.onChange}
          />
        </td>
        <td>
          <HoehendifferenzFeld
            label={labelRechts}
            values={messwerte.rechts}
            sperrpunkte={sperrpunkte}
            beurteilung={beurteilungRechts}
            index={index}
            aufstellflaechenTyp={aufstellflaechenTyp}
            onChange={this.props.onChange}
          />
        </td>
        {this.props.aufstellflaechenTyp === 'fahrzeug' && <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
            <SperrflaechenCheckbox
              abstand={parseInt(messpunkte[index], 10)}
              sperrpunkte={sperrpunkte}
              messwerte={messwerte}
              index={index}
              onChange={this.props.onChange}
            />
          </td>}
      </tr>
    );
  }
}

interface IAbstandFeldProps {
  index: number;
  values: string[];
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  onChange: () => void;
}

@observer
class AbstandFeld extends React.Component<IAbstandFeldProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    const { index, values } = this.props;
    let value = (event.target as HTMLInputElement).value;
    values[index] = value;
    this.props.onChange();
  }

  render() {
    const { values, index } = this.props;
    let validationState: 'warning' | undefined = undefined;
    if ((index > 0) && (parseFloat(values[index]) <= parseFloat(values[index - 1]))) {
      validationState = 'warning';
    }
    return (
      <FormGroup validationState={validationState}>
        <FormControl
          readOnly={true}
          tabIndex={-1}
          onChange={this.handleValueChanged}
          type="number"
          step="any"
          min="0"
          className="input-abstand"
          value={values[index]}
        />
      </FormGroup>
    );
  }
}

interface IHoehendifferenzFeldProps {
  index: number;
  label: string;
  values: string[];
  sperrpunkte: boolean[];
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  beurteilung?: ISesMesspunktErgebnis;
  onChange: () => void;
}

@observer
class HoehendifferenzFeld extends React.Component<IHoehendifferenzFeldProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    const { values, index } = this.props;
    let value = (event.target as HTMLInputElement).value;
    values[index] = value;
    this.props.onChange();
  }

  render() {
    const { values, index, label, beurteilung, aufstellflaechenTyp, sperrpunkte } = this.props;
    // Nullpunkt und per Sperrfläche (Fahrzeug-Aufstellfläche) deaktivierte Messpunkte erfordern keine Eingabe
    let readOnly = label === 'P0' || !this.store.editable;
    if (aufstellflaechenTyp === 'fahrzeug') {
      readOnly = readOnly || (sperrpunkte[index] === true);
    }
    // Validierung nur bei Punkten die eingegeben werden müssen
    let validationState: 'error' | 'warning' | undefined = undefined;
    const valueAtIndex = (index < values.length) ? values[index] : '';
    if (!readOnly) {
      if (valueAtIndex === '') {
        validationState = 'warning';
      } else if (beurteilung && !beurteilung.eingehalten) {
        validationState = 'error';
      }
    } else {
      if (beurteilung && !beurteilung.eingehalten) {
        validationState = 'error';
      }
    }
    const id = `${aufstellflaechenTyp}-${label}`;
    return (
      <FormGroup validationState={validationState} controlId={id}>
        <InputGroup>
          <InputGroup.Addon>
            <ControlLabel>{label}</ControlLabel>
          </InputGroup.Addon>
          <FormControl
            readOnly={readOnly}
            type="number"
            step="any"
            onChange={this.handleValueChanged}
            className="input-hoehendifferenz"
            value={valueAtIndex}
          />
        </InputGroup>
      </FormGroup>
    );
  }
}

interface ISperrflaechenCheckboxProps {
  index: number;
  messwerte: ISesMesswerte;
  sperrpunkte: boolean[];
  abstand: number;
  onChange: () => void;
}

/** Checkbox zum Markieren von Sperrflächen der Aufstellfläche */
@observer
class SperrflaechenCheckbox extends React.Component<ISperrflaechenCheckboxProps, {}> {

  @inject(SesAuswertungFlaechenRili2018Store) store: SesAuswertungFlaechenRili2018Store;

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    const { sperrpunkte, messwerte, index } = this.props;
    sperrpunkte[index] = (event.target as HTMLInputElement).checked;
    // Wenn Messwerte eingegeben wurden, entfernen, da diese im Back-End bei der Berechnung interpoliert werden müssen
    if (messwerte.links[index] !== '') {
      messwerte.links[index] = '';
    }
    if (messwerte.rechts[index] !== '') {
      messwerte.rechts[index] = '';
    }
    this.props.onChange();
  }

  render() {
    const { abstand, sperrpunkte, index } = this.props;
    // Sperrflächen sind nur zwischen 600 und 1900mm erlaubt
    const sperrflaecheErlaubt = (abstand >= 600) && (abstand <= 1900);
    return (
      sperrflaecheErlaubt ? (
        <FormControl
          className="checkbox-sperrpunkt"
          type="checkbox"
          checked={sperrpunkte[index]}
          onChange={this.handleValueChanged}
          disabled={!this.store.editable}
        />)
        :
        null
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ses/SesAuswertungFlaechenRili2018.tsx